import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import {
  CommonDatePicker,
  CommonInput,
  CommonSwitch,
  CommonTextarea,
  CrossButton,
  CustomSelect,
} from "components";
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import CItyDropdownForTrip from 'components/common/CItyDropdownForTrip';
import toast from 'react-hot-toast';
import AddAddressBook from 'modals/AddAddressBook';
import SelectConsigneeLrModal from 'modals/SelectConsigneeLrModal';
import SelectUnitLrModal from 'modals/SelectUnitLrModal';
import { errorSchema, utils } from 'helper';
import { UserContext } from 'context';
import AddLocationModal from "modals/AddLocationModal";
import { getStatesData } from '_services';
import { calculateDistance, extandEwayBill, getEwayBillLrData, updateLrInformation } from '_services/accountsServices/ewayBillServices';
import StorageService from 'utils/StorageServices/StorageServices';
import { GOOGLE_MAP_API_KEY } from 'lib/app-config';

const getTodayDate = (date) => {
  if (date) {
    const today = new Date(date);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  }
}

const formObj = {
  fromPlace: '',
  fromPincode: '',
  fromState: '',
  transDocDate: '',
  ewbNo: '',
  extnRsnCode: {},
  extnRemarks: {},
  remainingDistance: '',
  transMode: 1,  // 1=road, 2=rail, 3=air,4=ship,5=inTransit
  vehicleNo: '',
  consignmentStatus: 'M',  // M= inMovement, T= inTransit
  toPincode: '',
  from_location: {},
  to_location: {},
  locationPincode: '',
}

const editLocation = {
  company_id: "67ebac6a6894684905d6ad8c",
  name: "Dewas",
  countryCode: "IN",
  stateCode: "MP",
  stateName: "Madhya Pradesh",
  latitude: 22.9675929,
  longitude: 76.0534454
}

const ExtendEwayBillModal = (props) => {

  let { isOpen, onClose, callGetData = () => { } } = props;

  const { masterData } = useContext(UserContext);
  const [formValue, setFormValue] = useState(formObj);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingDistance, setLoadingDistance] = useState(false);

  const [unitInLR, setUnitInLR] = useState(false);
  const [consigneeInLR, setConsigneeInLR] = useState(false);

  const [addNewUnit, setAddNewUnit] = useState(false);
  const [selectUnitData, setSelectUnitData] = useState({});

  const [addNewConsignee, setAddNewConsignee] = useState(false);
  const [selectConsigneeData, setSelectConsigneeData] = useState({});

  const [extensionReasons, setExtensionReasons] = useState([]);

  const [existingLocation, setExistingLocation] = useState({});
  const [locationGstCode, setLocationGstCode] = useState('');

  const [extensionRemarksData, setExtensionRemarksData] = useState([]);
  const [extnRemarksField, setExtnRemarksField] = useState({});

  const [isLocationUpdate, setIsLocationUpdate] = useState(false);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [addressId, setAddressId] = useState({
    id: "",
    title: "address",
    view: false,
  });

  const [openLoction, setOpenLoction] = useState({
    open: false,
    action: 'add',
  });

  const fetchFromCity = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  let unitInLrModal = {
    isOpen: unitInLR,
    closeModal: (e) => setUnitInLR(false),
    nextModal: (e) => setAddNewUnit(true),
    selectUnit: (e) => setSelectUnitData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Select Address",
    submitTitle: "Submit",
    location_point: 1,
    consignor_id: isOpen?.consignor_id?._id,
    firmId:isOpen?.firm_id
  };

  let consigneeInLrModal = {
    isOpen: consigneeInLR,
    closeModal: (e) => setConsigneeInLR(false),
    nextModal: (e) => setAddNewConsignee(true),
    selectConsignee: (e) => setSelectConsigneeData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Select Address",
    submitTitle: "Submit",
    location_point: 2,
    consignor_id: isOpen?.consignor_id?._id,
    firmId:isOpen?.firm_id
  };

  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(stateObj, errorSchema.extandEwayBillSchema);
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  useEffect(() => {

    if (selectUnitData?.value) {
      const stateObj = {
        ...formValue,
        unit_id: selectUnitData?.value,
        from_location: {
          label: selectUnitData?.state?.label ? `${selectUnitData?.city?.label}, ${selectUnitData?.state?.label}` : "",
          name: selectUnitData?.city?.label || "",
          stateName: selectUnitData?.state?.label || "",
          _id: selectUnitData?.city?.label || ""
        }
      };
      setFormValue(stateObj);
    }
  }, [selectUnitData?.value]);

  useEffect(() => {
    if (selectConsigneeData?.value) {

      const stateObj = {
        ...formValue,
        consignee_id: selectConsigneeData?.value,
        to_location: {
          label: selectConsigneeData?.state?.label ? `${selectConsigneeData?.city?.label}, ${selectConsigneeData?.state?.label}` : "",
          name: selectConsigneeData?.city?.label || "",
          stateName: selectConsigneeData?.state?.label || "",
          _id: selectConsigneeData?.city?.label || ""
        }
      };
      setFormValue(stateObj);
    }
  }, [selectConsigneeData?.value]);

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...formValue, [name]: item };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.extandEwayBillSchema);
      if (validationResult === true) {
        setFormError({});
      } else {
        setFormError(validationResult);
      }
    }
  };

  const updateLocationLrInformation = async (payloadObj) => {
    try {
      const res = await updateLrInformation(payloadObj);
      if (res?.responseCode === 200) {
        callGetData();
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  }

  const callBackDataMaps = async (data) => {
    if (data?.postalCode) {
      setExistingLocation(data);
      handleOnChange('locationPincode', +data?.postalCode)
      setIsLocationUpdate(true);

      // let obj = {
      //   type: "Manually",
      //   location: `${data?.name} ${data?.stateName} , ${data?.postalCode} ${data?.countryName}`,
      //   datetime: new Date(),
      // }
      // let payload = {
      //   lr_id: isOpen?._id,
      //   company_id: isOpen?.company_id,
      //   eway_location: obj,
      // }
      // updateLocationLrInformation(payload);
    }
  }

  let gmapLocates = {
    isOpen: openLoction,
    closeModal: (e) => setOpenLoction((s) => ({ ...s, open: false, action: '' })),
    modalMainClass: "_dashCommon_Modal _mdModalLoction",
    modalTitle: openLoction?.action === 'edit' ? 'Update Location' : 'Add Location',
    submitTitle: openLoction?.action === 'edit' ? 'Update Location' : 'Add Location',
    callBackDataMap: callBackDataMaps,
    isEwayBillMap: true,
    editData: existingLocation,
    showPinCode: true,
    setLocationGstCode: (e) => setLocationGstCode(e)
  };

  const getLocationWiseData = async (lat, lng) => {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAP_API_KEY}`
    );
    const data = await response.json();

    let city = "";
    let pincode = "";
    let state = "";
    let stateCode = "";
    let gstStateCode = "";

    const stateCodeMap = {
      "ANDHRA PRADESH": "37",
      "ARUNACHAL PRADESH": "12",
      "ASSAM": "18",
      "BIHAR": "10",
      "CHHATTISGARH": "22",
      "DELHI": "07",
      "GOA": "30",
      "GUJARAT": "24",
      "HARYANA": "06",
      "HIMACHAL PRADESH": "02",
      "JAMMU AND KASHMIR": "01",
      "JHARKHAND": "20",
      "KARNATAKA": "29",
      "KERALA": "32",
      "MADHYA PRADESH": "23",
      "MAHARASHTRA": "27",
      "MANIPUR": "14",
      "MEGHALAYA": "17",
      "MIZORAM": "15",
      "NAGALAND": "13",
      "ODISHA": "21",
      "PUNJAB": "03",
      "RAJASTHAN": "08",
      "SIKKIM": "11",
      "TAMIL NADU": "33",
      "TELANGANA": "36",
      "TRIPURA": "16",
      "UTTAR PRADESH": "09",
      "UTTARAKHAND": "05",
      "WEST BENGAL": "19",
      "ANDAMAN AND NICOBAR ISLANDS": "35",
      "CHANDIGARH": "04",
      "DADRA AND NAGAR HAVELI AND DAMAN AND DIU": "26",
      "LAKSHADWEEP": "31",
      "PUDUCHERRY": "34",
      "LADAKH": "38",
    };

    if (data.results && data.results.length > 0) {
      const components = data.results[0].address_components;

      for (const comp of components) {
        if (comp.types.includes("locality")) {
          city = comp.long_name;
        } else if (comp.types.includes("postal_code")) {
          pincode = comp.long_name;
        } else if (
          comp.types.includes("administrative_area_level_1") ||
          comp.types.includes("political")
        ) {
          const possibleState = comp.long_name.toUpperCase();
          if (!state && stateCodeMap[possibleState]) {
            state = comp.long_name;
            stateCode = comp?.short_name?.toUpperCase();
            gstStateCode = stateCodeMap[possibleState];
          }
        }
      }
    }
    setExistingLocation({
      name: city,
      stateName: state,
      postalCode: pincode,
      stateCode: stateCode,
      latitude: lat,
      longitude: lng,
      city: city,
      state: state
    });
    setLocationGstCode(gstStateCode)
    handleOnChange('locationPincode', +pincode)
  };

  const getLatLongFromAddress = async (address) => {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${GOOGLE_MAP_API_KEY}`
    );
    const data = await response.json();
    const location = data?.results?.[0]?.geometry?.location;
    if (location?.lat && location?.lng) {
      getLocationWiseData(location?.lat, location?.lng)
    }
  }

  useEffect(() => {
    if (masterData?.eway_extnRemarks?.length > 0) {
      let array = masterData?.eway_extnRemarks?.map((el) => {
        return {
          label: el?.name,
          value: el?.id
        }
      })
      setExtensionReasons(array)
    }
  }, [masterData?.eway_extnRemarks])

  useEffect(() => {
    if (isOpen?._id) {
      setFormValue((s) => ({
        ...s,
        consignee_id: isOpen?.consignee_id?._id,
        ewbNo: isOpen?.eway_bill_number,
        unit_id: isOpen?.unit_id?._id,
        extnRsnCode: { label: 'Others', value: 99 },
        from_location: {
          label: `${isOpen?.from_location}, ${isOpen?.from_state}`,
          value: isOpen?.from_location,
          stateName: isOpen?.from_state,
          latitude: isOpen?.from?.lat,
          longitude: isOpen?.from?.long,
          name: isOpen?.from_location,
        },
        to_location: {
          label: `${isOpen?.to_location}, ${isOpen?.to_state}`,
          value: isOpen?.to_location,
          stateName: isOpen?.to_state,
          latitude: isOpen?.to?.lat,
          longitude: isOpen?.to?.long,
          name: isOpen?.to_location,
        },
        fromPincode: isOpen?.eway_details?.fromPincode ? isOpen?.eway_details?.fromPincode : '',
        toPincode: isOpen?.eway_details?.toPincode ? isOpen?.eway_details?.toPincode : '',
        eway_details: isOpen?.eway_details,
        remainingDistance: isOpen?.eway_remaingDist
      }))
      setSelectUnitData({
        label: isOpen?.unit_id?.name,
        value: isOpen?.unit_id?._id,
        code: isOpen?.unit_id?.code,
        city: {
          label: isOpen?.from_location,
          value: isOpen?.from_location,
        },
        state: {
          label: isOpen?.from_state,
          value: isOpen?.from_state,
        },
        pincode: isOpen?.unit_id?.pincode ? isOpen?.unit_id?.pincode : '-'
      });
      setSelectConsigneeData({
        label: isOpen?.consignee_id?.name,
        value: isOpen?.consignee_id?._id,
        code: isOpen?.consignee_id?.code,
        city: {
          label: isOpen?.to_location,
          value: isOpen?.to_location,
        },
        state: {
          label: isOpen?.to_state,
          value: isOpen?.to_state,
        },
        pincode: isOpen?.consignee_id?.pincode ? isOpen?.consignee_id?.pincode : '-'
      });

      if (isOpen?.eway_location?.location) {
        getLatLongFromAddress(isOpen?.eway_location?.location)
      }
    }
  }, [isOpen?._id, extensionReasons])

  const apiCallingFunction = async () => {
    try {
      let payloadObj = {
        company_id: StorageService.getCompanyId(),
        lr_id: isOpen?._id,
        branch_id: isOpen?.branch_id?._id,
        fromPlace: existingLocation?.city ? existingLocation?.city : formValue?.from_location?.name,
        fromPincode: formValue?.locationPincode,
        fromState: locationGstCode ? locationGstCode : '',
        ewbNo: formValue?.ewbNo ? formValue?.ewbNo?.toString() : '',
        extnRsnCode: formValue?.extnRsnCode?.value ? formValue?.extnRsnCode?.value : 99,
        extnRemarks: extnRemarksField?.label ? extnRemarksField?.label : 'Mechanical failure in vehicle caused delay.',
        remainingDistance: Number(formValue?.remainingDistance), // isOpen?.eway_details?.actualDist
        vehicleNo: formValue?.eway_details?.vehicleNo ? formValue?.eway_details?.vehicleNo : "MP06GA0599",
        transDocDate: formValue?.eway_details?.docDate ? formValue?.eway_details?.docDate : getTodayDate(new Date()),
        transMode: "1",  // 1=road, 2=rail, 3=air,4=ship,5=inTransit
        consignmentStatus: "M",  // M= inMovement, T= inTransit
      };

      const res = await extandEwayBill(payloadObj);
      if (res?.responseCode == 200) {
        if (res?.responseMessage) {
          toast.success(res?.responseMessage);
        }
        callGetData();
        setFormValue(formObj);
        setFormError({})
        setLoading(false);
        setExistingLocation({});
        onClose();
      } else {
        setLoading(false);
        // toast.error(res?.responseMessage);
      }
    } catch (error) {
      if (error) {
        toast.success(error);
      }
      setLoading(false);
    }
  }

  const submitExtendEwayBill = async (e) => {
    e.preventDefault();
    const validationResult = await utils?.checkFormError(formValue, errorSchema.extandEwayBillSchema);
    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      await apiCallingFunction();
      setFormError("");
    } else {
      setFormError(validationResult);
      setLoading(false);
    }
  }

  const cancelHandler = () => {
    setLoading(false);
    onClose(false)
    setFormValue(formObj);
    setFormError({})
    setExistingLocation({});
  }

  const callBackAddressData = () => {
    setAddressId((s) => ({
      ...s,
      id: '',
      title: "address",
      view: false,
      isDetailsOnly: false,
    }))
  };

  useEffect(() => {
    setExtnRemarksField({});
    if (formValue?.extnRsnCode?.value && masterData?.ewayExtensionReasonList?.length > 0) {
      let data = masterData?.ewayExtensionReasonList.find((el) => Number(el?.id) === Number(formValue?.extnRsnCode?.value))
      let remarkArray = data?.remarks?.map((el, index) => {
        return {
          label: el?.name,
          value: index + 1,
        }
      })
      if (remarkArray?.length > 0) {
        setExtensionRemarksData(remarkArray);
        setFormValue((s) => ({
          ...s,
          extnRemarks: remarkArray[0] // { label: "Mechanical failure in vehicle caused delay.", value: 1 }
        }))
        setExtnRemarksField(remarkArray[0]);
      }
    }
  }, [formValue?.extnRsnCode?.value, masterData?.ewayExtensionReasonList])

  const fetchDistace = async () => {
    setLoadingDistance(true);
    try {
      let payload = {
        company_id: StorageService.getCompanyId(),
        from_pincode: formValue?.locationPincode.toString(),
        to_pincode: formValue?.toPincode.toString()
      }
      const res = await calculateDistance(payload);
      if (res?.responseCode === 200) {
        setLoadingDistance(false);
        let distanceValue = res?.data?.distance_km ? Number(res?.data?.distance_km) : 0
        handleOnChange('remainingDistance', distanceValue)

        let obj = {
          type: "Manually",
          location: `${existingLocation?.name} ${existingLocation?.stateName} , ${existingLocation?.postalCode} ${existingLocation?.countryName}`,
          datetime: new Date(),
        }
        let payload = {
          lr_id: isOpen?._id,
          company_id: isOpen?.company_id,
          eway_location: obj,
          eway_remaingDist: Number(distanceValue)
        }
        updateLocationLrInformation(payload);

      } else {
        setLoadingDistance(false);
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
      }
    } catch (error) {
      setLoadingDistance(false);
      toast.error(error?.message || "Something went wrong");
    }
  }

  useEffect(() => {
    if (isLocationUpdate && formValue?.locationPincode && formValue?.toPincode?.toString().length === 6) {
      fetchDistace();
      setIsLocationUpdate(false);
    }
  }, [formValue?.locationPincode, formValue?.toPincode, isLocationUpdate])

  const lrInformation = async (payloadObj, dataObj) => {
    try {
      let payload = {
        lr_id: isOpen?._id,
        company_id: isOpen?.company_id,
        is_eway_fetch: true,
        eway_details: payloadObj,
        eway_bill_date: dataObj?.eway_bill_date,
        eway_expiry_date: dataObj?.eway_expiry_date
      }
      const res = await updateLrInformation(payload);
      if (res?.responseCode === 200) {
        callGetData();
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  }

  const fetchEwayBillData = async () => {
    try {
      let object = {
        is_mobile: true,
        consignor_id: isOpen?.consignor_id?._id ? isOpen?.consignor_id?._id : '',
        branch_id: isOpen?.branch_id?._id ? isOpen?.branch_id?._id : '',
        company_id: isOpen?.company_id,
        ewbNo: isOpen?.eway_bill_number ? isOpen?.eway_bill_number?.toString() : null,
      }
      const ewayBillResponse = await getEwayBillLrData(object);
      if (ewayBillResponse?.responseCode == 200) {
        let values = ewayBillResponse?.data;
        let values1 = ewayBillResponse?.data?.ewb_details;
        let dataObj = {
          eway_bill_date: values1?.ewayBillDate,
          eway_expiry_date: values1?.validUpto
        }
        let updateLrObject = {
          transDocNo: values1?.VehiclListDetails[0]?.docNo ? values1?.VehiclListDetails[0]?.docNo : '',
          vehicleNo: values1?.VehiclListDetails[0]?.vehicleNo ? values1?.VehiclListDetails[0]?.vehicleNo : '',
          docDate: values1?.docDate ? values1?.docDate : new Date(),
          actualDist: values1?.actualDist ? values1?.actualDist : 0,
          extendedTimes: values1?.extendedTimes ? values1?.extendedTimes : 0,
          transactionType: values1?.transactionType ? values1?.transactionType : '',
          fromPincode: values1?.fromPincode ? values1?.fromPincode : '',
          toPincode: values1?.toPincode ? values1?.toPincode : ''
        }
        setFormValue((s) => ({
          ...s,
          vehicleNo: values1?.VehiclListDetails[0]?.vehicleNo ? values1?.VehiclListDetails[0]?.vehicleNo : '',
          fromPincode: values1?.fromPincode ? values1?.fromPincode : '',
          toPincode: values1?.toPincode ? values1?.toPincode : '',
        }));
        lrInformation(updateLrObject, dataObj);
      }
    } catch (error) {
    }
  }

  useEffect(() => {
    if (!isOpen?.eway_details?.fromPincode && !isOpen?.eway_details?.toPincode) {
      fetchEwayBillData();
    }
  }, [!isOpen?.eway_details?.fromPincode, !isOpen?.eway_details?.toPincode])

  return (
    <>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">{isOpen?.extend_details ? 'Extend Eway Details' : 'Extend Eway Bill'}</h5>
        <CrossButton type="button" className="_switchBtn  __animEffect_btn" onClick={cancelHandler} style={{ marginLeft: 'auto' }}>
          <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black"
            />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className="pr_procssBx" style={{ marginBottom: "9px" }}>

          <div className="_lrdMax">
            <div className="flxInr">
              {isOpen?._id ? <div className="halfDiv">
                <CItyDropdownForTrip
                  label="From Station * "
                  placeholder="Select a city"
                  fetchData={fetchFromCity}
                  selectedItem={formValue?.from_location}
                  onChange={(data) => onhandleSelect(data, 'from_location')}
                  error={!!formError["from_location.name"]}
                  errorMessage={formError["from_location.name"]}
                  disabled={isOpen?.extend_details ? true : false}
                  // isAddButton={true}
                  // addButtonAction={(e) => addNewItemHandler(e, "from")}
                  pageSize={20}
                />
              </div> : <></>}

              {isOpen?._id ? <div className="halfDiv">
                <CItyDropdownForTrip
                  label="To Station * "
                  placeholder="Select a city"
                  fetchData={fetchFromCity}
                  selectedItem={formValue?.to_location}
                  onChange={(data) => onhandleSelect(data, 'to_location')}
                  error={!!formError["to_location.name"]}
                  errorMessage={formError["to_location.name"]}
                  disabled={isOpen?.extend_details ? true : false}
                  // isAddButton={true}
                  // addButtonAction={(e) => addNewItemHandler(e, "to")}
                  pageSize={20}
                />
              </div> : <></>}
            </div>

            <div className="_csgAdd_bx mt-3">
              <div className="halfDiv">
                {/* <button
                  className="addConsignee_lBtn"
                // onClick={(e) => setUnitInLR(!unitInLR)}
                >
                  {" "}
                  + Add Unit{" "}
                </button> */}
                {selectUnitData?.value ? (
                  <div className="_unit_detailBxs _avPointer">
                    <div className='flex_extand_avt'>
                      <span className='extand_address_name'> Unit </span>
                      <button
                        className='view_btn_extand'
                        onClick={() => {
                          setAddressId({
                            ...addressId,
                            id: selectUnitData?.value,
                            title: "address",
                            view: true,
                            isDetailsOnly: true,
                          });
                          setShowOffcanvas(true);
                        }}
                      >
                        View
                      </button>
                    </div>
                    <p> Name : {selectUnitData?.label} </p>
                    <p> Code : {selectUnitData?.code} </p>
                    <p>
                      {" "}
                      Address :{" "}
                      {selectUnitData?.address_line1
                        ? selectUnitData?.address_line1
                        : "-"}{" "}
                      {selectUnitData?.city?.label
                        ? selectUnitData?.city?.label
                        : "-"}{" "}
                      {selectUnitData?.state?.label
                        ? selectUnitData?.state?.label
                        : "-"}{" "}
                    </p>
                    <p> Pin Code : {selectUnitData?.pincode ? selectUnitData?.pincode : '-'} </p>
                    {!isOpen?.extend_details ? <div className="_addDel_bx mt-3">
                      <button
                        className="_pickN_dropBtn"
                        onClick={(e) =>
                          setUnitInLR({ _id: selectUnitData?.value })
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>Add New</span>
                      </button>

                      <button
                        className="_deleteBtn"
                        onClick={(e) => {
                          setSelectUnitData(null);
                          handleOnChange("unit_id", "");
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M2.83333 17C2.31389 17 1.86937 16.8152 1.49978 16.4456C1.13019 16.076 0.945074 15.6312 0.944444 15.1111V2.83333H0V0.944444H4.72222V0H10.3889V0.944444H15.1111V2.83333H14.1667V15.1111C14.1667 15.6306 13.9819 16.0754 13.6123 16.4456C13.2427 16.8158 12.7979 17.0006 12.2778 17H2.83333ZM12.2778 2.83333H2.83333V15.1111H12.2778V2.83333ZM4.72222 13.2222H6.61111V4.72222H4.72222V13.2222ZM8.5 13.2222H10.3889V4.72222H8.5V13.2222Z"
                            fill="#C41F1F"
                          ></path>
                        </svg>
                        <span>Remove</span>
                      </button>
                    </div> : <></>}
                  </div>
                ) : (
                  <button
                    className="addConsignee_lBtn"
                    disabled={isOpen?.extend_details ? true : false}
                    onClick={(e) => setUnitInLR(!unitInLR)}
                  >
                    {" "}
                    + Add Unit{" "}
                  </button>
                )}
                {formError?.unit_id && (
                  <span className="input_drop_error">{formError?.unit_id}</span>
                )}
              </div>

              <div className="halfDiv">
                {/* <button
                  className="addConsignee_lBtn"
                // onClick={(e) => setConsigneeInLR(!consigneeInLR)}
                >
                  + Add Consignee
                </button> */}
                {selectConsigneeData?.value ? (
                  <div className="_unit_detailBxs">
                    <div className='flex_extand_avt'>
                      <span className='extand_address_name'> Consignee </span>
                      <button
                        className='view_btn_extand'
                        onClick={() => {
                          setAddressId({
                            ...addressId,
                            id: selectConsigneeData?.value,
                            title: "address",
                            view: true,
                            isDetailsOnly: true,
                          });
                          setShowOffcanvas(true);
                        }}
                      >
                        View
                      </button>
                    </div>
                    <p> Name : {selectConsigneeData?.label} </p>
                    <p>
                      {" "}
                      Code : {
                        selectConsigneeData?.code
                      }{" "}
                    </p>
                    <p>
                      {" "}
                      Address :{" "}
                      {selectConsigneeData?.address_line1
                        ? selectConsigneeData?.address_line1
                        : "-"}{" "}
                      {selectConsigneeData?.city?.label
                        ? selectConsigneeData?.city?.label
                        : "-"}{" "}
                      {selectConsigneeData?.state?.label
                        ? selectConsigneeData?.state?.label
                        : "-"}{" "}
                    </p>
                    <p> Pin Code : {selectConsigneeData?.pincode ? selectConsigneeData?.pincode : '-'} </p>
                    {!isOpen?.extend_details ? <div className="_addDel_bx mt-3">
                      <button
                        className="_pickN_dropBtn"
                        onClick={(e) =>
                          setConsigneeInLR({ _id: selectConsigneeData?.value })
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>Add New</span>
                      </button>

                      <button
                        className="_deleteBtn"
                        onClick={(e) => {
                          setSelectConsigneeData(null);
                          handleOnChange("consignee_id", "");
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M2.83333 17C2.31389 17 1.86937 16.8152 1.49978 16.4456C1.13019 16.076 0.945074 15.6312 0.944444 15.1111V2.83333H0V0.944444H4.72222V0H10.3889V0.944444H15.1111V2.83333H14.1667V15.1111C14.1667 15.6306 13.9819 16.0754 13.6123 16.4456C13.2427 16.8158 12.7979 17.0006 12.2778 17H2.83333ZM12.2778 2.83333H2.83333V15.1111H12.2778V2.83333ZM4.72222 13.2222H6.61111V4.72222H4.72222V13.2222ZM8.5 13.2222H10.3889V4.72222H8.5V13.2222Z"
                            fill="#C41F1F"
                          ></path>
                        </svg>
                        <span>Remove</span>
                      </button>
                    </div> : <></>}
                  </div>
                ) : (
                  <button
                    className="addConsignee_lBtn"
                    disabled={isOpen?.extend_details ? true : false}
                    onClick={(e) => setConsigneeInLR(!consigneeInLR)}
                  >
                    + Add Consignee
                  </button>
                )}
                {formError?.consignee_id && (
                  <span className="input_drop_error">
                    {formError?.consignee_id}
                  </span>
                )}
              </div>
            </div>

            <div className='__gpsLocateBx mt-4'>
              <p>Last Location / Extension Location</p>
              <span> {moment(new Date()).format('DD MMM YYYY')} | {moment(new Date()).format('hh:mm A')} </span>
            </div>

            <div className='mb-3'>
              {existingLocation?.name ? <div className='__editLocatePlace_bx'>
                <p> {existingLocation?.name} {existingLocation?.stateName} ,{existingLocation?.postalCode ? existingLocation?.postalCode : ''} {existingLocation?.countryName} </p>
                <button disabled={isOpen?.extend_details ? true : false} className='__editNewComm_btn' onClick={() => setOpenLoction((s) => ({ ...s, open: true, action: 'edit' }))}> Edit </button>
              </div>
                :
                <>
                  <button className='__addLocatePlace_bx' onClick={() => setOpenLoction((s) => ({ ...s, open: true, action: 'add' }))} disabled={isOpen?.extend_details ? true : false}>
                    <p> + Add Current Location * </p>
                  </button>
                  {formError?.locationPincode ? (
                    <span className="input_drop_error">
                      {formError?.locationPincode}
                    </span>
                  ) : <></>}
                </>
              }
            </div>

            <p style={{ marginBottom: '2px' }}> Eway Bill PIN Code </p>
            <div className="flxInr mt-3">
              <div className="halfDiv">
                <CommonInput
                  type="text"
                  label="From Pin Code * "
                  placeholder="From Pin Code * "
                  name="fromPincode"
                  maxLength="6"
                  onInput={utils.maxLengthCheck}
                  disabled
                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                  value={formValue.fromPincode}
                  focus={
                    !!(
                      typeof formError === "object" &&
                      formError?.fromPincode
                    )
                  }
                  error={
                    !!(typeof formError === "object")
                      ? formError?.fromPincode
                      : ""
                  }
                  onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                />
              </div>

              <div className="halfDiv">
                <CommonInput
                  type="text"
                  label="To Pin Code * "
                  placeholder="To Pin Code * "
                  name="toPincode"
                  maxLength="6"
                  disabled
                  onInput={utils.maxLengthCheck}
                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                  value={formValue.toPincode}
                  focus={
                    !!(
                      typeof formError === "object" &&
                      formError?.toPincode
                    )
                  }
                  error={
                    !!(typeof formError === "object")
                      ? formError?.toPincode
                      : ""
                  }
                  onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                />
              </div>

              <div className="singleDiv _relatePos">
                <CommonInput
                  type="text"
                  label="Remaining Distance * "
                  placeholder="Remaining Distance  * "
                  name="remainingDistance"
                  maxLength="10"
                  disabled={isOpen?.extend_details ? true : false}
                  onInput={utils.maxLengthCheck}
                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                  value={formValue.remainingDistance}
                  focus={
                    !!(
                      typeof formError === "object" &&
                      formError?.remainingDistance
                    )
                  }
                  error={
                    !!(typeof formError === "object")
                      ? formError?.remainingDistance
                      : ""
                  }
                  onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                />
                {
                  isOpen?.extend_details ?
                    <button className='_highDis_Span _avPointer' onClick={() => fetchDistace()} disabled={isOpen?.extend_details}> Fetch Distance </button>
                    :
                    (loadingDistance ?
                      <span className='_highDis_Span'> Loading...</span> :
                      <button className='_highDis_Span _avPointer' onClick={() => fetchDistace()} disabled={!formValue?.locationPincode || formValue?.toPincode?.toString()?.length !== 6}> Fetch Distance </button>
                    )
                }
              </div>
            </div>
          </div>

          <div className='__extendEw_ctsx' style={{ background: 'white' }}>

            <div className='__extenReason'>
              <p style={{ marginBottom: '20px' }}>Extension Reason</p>

              <div>
                <div className='singleDiv'>
                  <CustomSelect
                    options={extensionReasons}
                    name="extnRsnCode"
                    flotingLabel="Extension Reason"
                    placeholder="Extension Reason"
                    value={formValue.extnRsnCode}
                    error={formError["extnRsnCode.label"]}
                    disabled={isOpen?.extend_details ? true : false}
                    onSelect={(data) => onhandleSelect(data, 'extnRsnCode')}
                  />
                </div>
                <div className='singleDiv mt-4'>
                  <CustomSelect
                    options={extensionRemarksData}
                    name="extnRemarks"
                    flotingLabel="Remarks"
                    placeholder="Remarks"
                    value={extnRemarksField?.label ? extnRemarksField : {}}
                    disabled={isOpen?.extend_details ? true : false}
                    error={formError["extnRemarks.label"]}
                    onSelect={(data) => {
                      onhandleSelect(data, 'extnRemarks');
                      setExtnRemarksField(data);
                    }}
                  />
                </div>
              </div>
            </div>
          </div >

        </div >
      </div>

      <div className="offcanvas-footer">
        {
          !isOpen?.extend_details ?
            <button className="_addComm_btn " onClick={(e) => submitExtendEwayBill(e)} disabled={loading || !formValue.toPincode}> {loading ? 'Loading...' : 'Extend Eway Bill'}</button>
            : <></>
        }
        <button className="_cancel_btn" onClick={() => cancelHandler()} disabled={loading}> Cancel </button>
      </div>

      {/* all type of modal ---------- */}

      {unitInLR && <SelectUnitLrModal {...unitInLrModal} />}

      {consigneeInLR && <SelectConsigneeLrModal {...consigneeInLrModal} />}

      {/* Add New Consignee Offcanvas - Start */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewConsignee ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewConsignee ? "visible" : "hidden" }}
      >
        {addNewConsignee && (
          <AddAddressBook
            isOpen={addNewUnit}
            onClose={(e) => setAddNewConsignee(false)}
            callBackAddressData={(e) => setConsigneeInLR(true)}
            selectedAssociateParty={isOpen}
            isLocationPoint={2}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={addNewConsignee ? "offBack_drop" : ""}></div>

      {/* Add New Consignee Offcanvas - End */}

      {/* Add New Unit Offcanvas - Start */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewUnit ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewUnit ? "visible" : "hidden" }}
      >
        {addNewUnit && (
          <AddAddressBook
            isOpen={addNewUnit}
            onClose={(e) => setAddNewUnit(false)}
            callBackAddressData={(e) => setUnitInLR(true)}
            selectedAssociateParty={isOpen}
            isLocationPoint={1}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={addNewUnit ? "offBack_drop" : ""}></div>

      {/* Add New Unit Offcanvas - End */}

      {openLoction?.open && <AddLocationModal {...gmapLocates} />}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
      >
        {showOffcanvas && (
          <AddAddressBook
            isOpen={showOffcanvas}
            onClose={(e) => {
              setAddressId({ id: "", title: "address", view: false });
              setShowOffcanvas(false);
            }}
            id={addressId}
            callBackAddressData={callBackAddressData}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={showOffcanvas ? "offBack_drop" : ""}></div>

    </>
  )
}

export default React.memo(ExtendEwayBillModal);